import axios from "axios";
import { Constants } from "../utils/Constants";

const BASE_URL = Constants.baseUrl;

export const getEmpresa = () => axios.get(`${BASE_URL}/configuracoes/empresa`);

export const updateEmpresa = (data) => axios.put(`${BASE_URL}/configuracoes/empresa`, data);

export const getCartoes = () => axios.get(`${BASE_URL}/configuracoes/cartoes`);

export const storeCartao = (data) => axios.post(`${BASE_URL}/configuracoes/cartoes`, data);

export const destroyCartao = (id) => axios.delete(`${BASE_URL}/configuracoes/cartoes/${id}`);

export const setPrincipalCartao = (id) => axios.patch(`${BASE_URL}/configuracoes/cartoes/${id}/principal`);

export const updatePassword = (data) => axios.patch(`${BASE_URL}/user/update-password`, data);
